import { IconProps } from './IconProps';

export const MarkerIcon = ({
  className,
  style,
  fill = 'black',
  width = 16,
  height = 10,
}: {
  className?: string;
  style?: Record<string, unknown>;
  fill?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
      style={style}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        className={className}
        style={style}
      >
        <g clip-path="url(#clip0_3900_3162)">
          <path
            d="M1.33534 9.70923C1.17026 9.54415 1.08772 9.35367 1.08772 9.1378C1.08772 8.92192 1.17026 8.73145 1.33534 8.56637L5.94487 3.95685C6.02106 3.88065 6.1036 3.82656 6.19249 3.79456C6.28137 3.76307 6.37661 3.74732 6.4782 3.74732C6.57979 3.74732 6.67502 3.76307 6.76391 3.79456C6.8528 3.82656 6.93534 3.88065 7.01153 3.95685L9.52582 6.47113L14.402 0.985417C14.5417 0.820338 14.7228 0.737797 14.9452 0.737797C15.1672 0.737797 15.3544 0.813988 15.5068 0.966369C15.6465 1.10605 15.7196 1.27443 15.7262 1.47151C15.7323 1.66808 15.6655 1.84256 15.5258 1.99494L10.0592 8.14732C9.98296 8.23621 9.89737 8.30275 9.80239 8.34694C9.7069 8.39164 9.60836 8.41399 9.50677 8.41399C9.40518 8.41399 9.3069 8.39494 9.21191 8.35685C9.11642 8.31875 9.03058 8.26161 8.95439 8.18542L6.4782 5.70923L2.4782 9.70923C2.31312 9.8743 2.12264 9.95685 1.90677 9.95685C1.6909 9.95685 1.50042 9.8743 1.33534 9.70923Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_3900_3162">
            <rect width="16" height="9.90476" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </svg>
  );
};

